{
  "it": {
    "sales": {
      "actions": {
        "assign_lead": "Assegna lead",
        "publish": "Pubblica",
        "remove_lead_from_deal": "Rimuovi lead dalla trattativa",
        "unpublish": "Annulla pubblicazione",
        "update_status": "Aggiorna stato",
        "upload_document": "Carica contratto",
        "view_contracts": "Visualizza contratti"
      },
      "attributes": {
        "status": "Stato"
      },
      "labels": {
        "assign_customer": "Assegna cliente",
        "assign_customer_mark_sold": "Assegni un cliente per contrassegnare l'unità come venduta",
        "assign_lead_to_unit": "Assegna lead all'unità",
        "assigned_by": "Assegnato da",
        "contracts": "Contratti",
        "expiry_date": "Data di scadenza della prenotazione",
        "go_to_unit_part_1": "Questa unità è stata venduta. Per aggiornare lo stato, deve andare alla",
        "go_to_unit_part_2": "e disassegnare prima da lì il cliente, come misura di sicurezza.",
        "interested_leads": "{count} lead interessati",
        "internal_note": "Nota interna",
        "latest_phase": "Ultima fase",
        "lead_existing": "Lead esistente",
        "lead_new": "Nuovo lead",
        "leads_count": "{count} lead",
        "mark_as_sold": "Contrassegna come venduta",
        "not_published_sales_partners": "Non pubblicata per i partner di vendita",
        "not_shown_interest": "Questo lead non ha mostrato interesse per nessuna unità",
        "note_explainer": "Questa nota è visibile solo al Suo team",
        "publish_unit": "Pubblica 1 unità per tutti i partner di vendita | Pubblica {count} unità per tutti i partner di vendita",
        "published_sales_partners": "Pubblicata per i partner di vendita",
        "reserved_by": "Riservata da",
        "reserved_warning": "Questa unità è attualmente riservata da {lead_name}. Se la contrassegna come venduta, questa prenotazione verrà annullata.",
        "sales": "Vendite",
        "selling_price": "Prezzo di vendita",
        "selling_price_max": "Prezzo di vendita massimo",
        "selling_price_min": "Prezzo di vendita minimo",
        "sold_date": "Venduta il",
        "sorting": {
          "deal_lead_group_name": "Lead",
          "deal_status": "Stato",
          "name": "Unità"
        },
        "status": "Stato",
        "statuses": {
          "available": "Disponibile",
          "interested": "Interessata",
          "lost": "Persa",
          "reserved": "Riservata",
          "sold": "Venduta"
        },
        "tab_sales_documents": "Documenti",
        "tab_sales_tickets": "Conversazioni",
        "tab_sales_units": "Unità",
        "unit": "Unità",
        "unit_information_page": "pagina informazioni unità",
        "unit_sales_status_header": "Questa unità è in vendita",
        "unpublish_unit": "Annulla la pubblicazione di 1 unità per tutti i partner di vendita | Annulla la pubblicazione di {count} unità per tutti i partner di vendita",
        "update_sales_status": "Aggiorna lo stato di vendita dell'unità",
        "upload_sales_doc": "Carica contratto"
      },
      "toasts": {
        "lead_assigned": "Lead assegnato"
      },
      "validation": {
        "already_reserved_sold": "Questa unità è già riservata per un altro lead.",
        "already_reserved_sold_info": "Se è sicuro di voler cambiare lo stato per il lead attuale, deve prima cambiare lo stato della trattativa che ha attualmente la priorità. Una volta cambiato lo stato dell'altra trattativa, può tornare e aggiornare lo stato in sicurezza.",
        "need_sold_date": "È necessaria la data di questa vendita",
        "reserved_expiry_date": "È necessaria una data di scadenza per questa prenotazione"
      }
    }
  }
}
